<template>
  <el-dialog title="派发积分" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap dialog_auth">
      <p>派发积分需要企业后台管理员授权确认，填写验证码后方可继续操作</p>
      <p>绑定手机号：{{phone}}</p>
      <p>
        <label>验证码：</label>
        <el-input class="w160" type="text" placeholder="输入验证码" v-model="formdata.code"></el-input>
        <el-button @click="btndisabled?btnPhoneCode(0):''" class="btnPhoneCode btnGetCode" :disabled="!btndisabled">{{codeWord}}</el-button>
      </p>
       <p class="mt-20">
        <label>积分数量：</label>
        <el-input class="w160" type="number" placeholder="请填写积分数量" v-model="formdata.score"></el-input>
      </p>
      <p><br/></p>
      <p>*对同一个手机号码发送短信验证码，支持1条/分钟，5条/小时 ，累计10条/天</p>
      <p>积分实时到账，访客微信列表会收到相关服务通知</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitPhoneFn">提 交</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
export default {
  name: "integralDialog",
  props: ["visible", "vid", "phone"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      formdata: {
        code: '',
        score: '',
        visitor_id: ''
      },
      // 验证码
      allTime: 60,
      codeWord: '发送验证码',
      btndisabled: true,
      flag: true
    }
  },
  methods: {
    btnPhoneCode(option) {
      if (this.flag) {
        this.flag = false
        this.axios
          .post(api.customer_integral_sms, {visitor_id: this.vid})
          .then(response => {
            if (response.data.code == 0) {
              this.btndisabled = false
              this.getCode()
            } 
          })
          .catch(() => {});
      }
    },
    getCode() {
      // codeWord: '发送验证码'
      let self_ = this
      this.btndisabled = false
      this.codeWord = '60s'
      this.setInter = setInterval(
        function () {
          let numVal = self_.allTime - 1;
          let codeText = numVal + 's'
          if (numVal <= 0) {
            codeText = '重新获取验证码';
            numVal = 60;
            self_.codeWord = '重新获取'
            self_.flag = true
            self_.btndisabled = true
            clearInterval(self_.setInter)
          }
          ;
          self_.allTime = numVal
          self_.codeWord = codeText
        }, 1000);
    },
    submitPhoneFn() {
      if (!this.formdata.code) {
        this.$message.warning('请填写验证码');
        return
      }
      if (!this.formdata.score) {
        this.$message.warning('请填写积分数量');
        return
      }
      if (!(/(^[1-9]\d*$)/.test(this.formdata.score))) { 
        this.$message.warning('积分数量请输入正整数');
        return        
      }
      if (this.formdata.score > 99999) {
        this.$message.warning('积分数量不能超过 99999');
        return          
      }
      this.formdata.visitor_id = this.vid;
      this.axios
        .post(api.customer_give_integral, this.formdata)
        .then(response => {
          if (response.data.code == 0) {
            this.$message.success(response.data.msg);
            this.$emit('update:visible',false);
          }
        })
        .catch(() => {});      
    }
  }
};
</script>
